<template>
<div class="chapter">
<div class="inner_page">
<h1 class="left"><a href="#/007toc#otherbooksby">Also by Gregory A. Boyd</a></h1>
<p class="center"><i>The Myth of a Christian Nation</i></p>
<p class="center"><i>The Myth of the Christian Religion</i></p>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003otherbooksby.vue?33afd576